import React from 'react';
import ModuleTopic from '../../components/ModuleTopic';

interface ITopicProps {
  settings: any;
}

const TopicThirdParty: React.FunctionComponent<ITopicProps> = ({
  settings,
}) => <ModuleTopic settings={settings} moduleKey="thirdparty" />;

export default TopicThirdParty;
